export const validation = {
  name: 'required|min:5|max:50',
  title_es: 'min:3|max:255',
  subtitle_es: 'min:3|max:255',
  description_es: 'min:3',
  image: 'required|min:3',
  position: 'min_value:1|max:2',
  status_id: 'required|min_value:1|numeric|max_value:9',
  gallery_id: 'required|numeric|min_value:1|max:11',
  url: 'url'
}

export const ImageFields = function () {
  return {
    name: null,
    title_es: null,
    subtitle_es: null,
    description_es: null,
    image: null,
    status_id: null,
    gallery_id: null,
    position: null,
    url: null
  }
}

export const statusList = [
  {
    id: 1,
    name: 'Activa'
  },
  {
    id: 2,
    name: 'Inactiva'
  }
]

export const texts = {
  galleryImageEdit: {
    title: 'Editar Imagen Existente',
    subtitle: 'Edita la información de la imagen, cambiar imagen, contenido, posición.',
    submit: 'Actualizar Imagen',
    messages: {
      success: {
        title: 'IMAGEN ACTUALIZADA',
        text: 'Esta imagen ha sido actualizada correctamente'
      }
    }
  },
  galleryImageNew: {
    title: 'Añadir Nueva Imagen',
    subtitle: 'Crear nuevas imágenes para galerías del sitio web.',
    submit: 'Crear Imagen',
    messages: {
      success: {
        title: 'IMAGEN CREADA',
        text: 'Se ha creado correctamente la nueva imagen'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/galleries/image.mocks.js